import {
  Component,
  ViewChild,
  AfterContentChecked
} from '@angular/core';

import {
  SkyModalInstance,
  SkySectionedFormComponent
} from '../../core';


export class SkySectionedModalFormDemoComponent implements AfterContentChecked {

  
  public sectionedFormComponent: SkySectionedFormComponent;

  public activeIndexDisplay: number = undefined;
  public activeTab = true;

  private _activeIndex: number = undefined;

  constructor(public instance: SkyModalInstance) {}

  public ngAfterContentChecked() {
    this.activeIndexDisplay = this._activeIndex;
  }

  public updateIndex(newIndex: number) {
    this._activeIndex = newIndex;
  }

  public tabsHidden() {
    return !this.sectionedFormComponent.tabsVisible();
  }

  public showTabs() {
    this.sectionedFormComponent.showTabs();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-sectioned-modal-form-demo',
  template: `<sky-modal>
  <sky-modal-header>
      Sectioned form — Index: {{ activeIndexDisplay }}
  </sky-modal-header>
  <sky-modal-content>
    <sky-sectioned-form (indexChanged)="updateIndex($event)">
      <sky-sectioned-form-section heading="Basic information">
        <sky-demo-information-form>
        </sky-demo-information-form>
      </sky-sectioned-form-section>
      <sky-sectioned-form-section heading="Addresses" itemCount="2" [active]="activeTab">
        <sky-demo-address-form></sky-demo-address-form>
      </sky-sectioned-form-section>
      <sky-sectioned-form-section heading="Phone numbers" itemCount="3">
        <sky-demo-phone-form></sky-demo-phone-form>
      </sky-sectioned-form-section>
    </sky-sectioned-form>
  </sky-modal-content>
  <sky-modal-footer>
    <button
      type="button"
      *ngIf="tabsHidden()"
      class="sky-btn sky-btn-secondary"
      (click)="showTabs()"
    >
      Show sections
    </button>
    <button
      type="button"
      class="sky-btn sky-btn-primary"
      (click)="instance.save('Something cool')"
    >
      Save
    </button>
    <button
      type="button"
      class="sky-btn sky-btn-link"
      (click)="instance.cancel('Nevermind')"
    >
      Cancel
    </button>
  </sky-modal-footer>
  </sky-modal>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalInstance, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sectionedFormComponent': [{ type: ViewChild, args: [SkySectionedFormComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
